import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ReviewsIcon from '@mui/icons-material/Reviews';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { CreateLocationInput, EditLocationInput } from '__generated__/graphql';
import { LocationBar } from 'components';
import { useToastNofication } from 'context/toastContext';
import { useCreateLocation } from 'api/hooks/useLocation';
import { LocationForm } from './LocationForm';

function LocationCreateForm() {
  const { createLocation, createLocationLoading, createLocationError } = useCreateLocation();
  const navigate = useNavigate();
  const { addToast } = useToastNofication();

  const onSubmit = async (input: CreateLocationInput | EditLocationInput) => {
    const response = await createLocation({
      variables: {
        input,
      },
    });
    addToast(response, 'CreateLocation');
    if (!createLocationLoading && !createLocationError) {
      navigate('/locations');
    }
  };

  return (
    <>
      <Helmet>
        <title>Location Create</title>
      </Helmet>
      <LocationBar section="Location" page="Location Create Form" Icon={ReviewsIcon} />
      <div className="my-10 px-4 md:px-[5%]">
        <button
          data-cy="location-detail-back"
          type="button"
          className="text-gray-500 font-semibold text-md leading-md flex items-center"
          onClick={() => navigate('/locations')}
        >
          <ArrowLeftIcon className="mr-2 w-5 h-5" /> Back
        </button>
        <LocationForm onSubmit={onSubmit} formSubmitting={false} formSubmitError={undefined} />
      </div>
    </>
  );
}

export default LocationCreateForm;
